import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './scss/styles.scss';
import './scss/questions.scss';
import './scss/carousel.scss';
import './scss/charts.scss';
import './scss/conferences.scss';
import './scss/dashboard.scss';
import './scss/progressBar.scss';
import Amplify from "@aws-amplify/core";
import "@aws-amplify/auth";

import { BrowserRouter } from "react-router-dom";
import { ServiceWorker } from '@aws-amplify/core';

import App from './App';

import awsconfig from "./aws-exports";

Amplify.configure(awsconfig);



const serviceWorker = new ServiceWorker();

ReactDOM.render(
  <React.StrictMode>
   <BrowserRouter>
    <App />
  </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.register('/service-worker.js', '/');
